import { pushDataLayer, type DataLayerEvent, type newDataLayerEvent } from './push-data-layer';

export function usePushDataLayer() {
  const handlePushDataLayer = (eventData: DataLayerEvent) => {
    if (!eventData.event) {
      console.error('Event name is required for pushDataLayer');
      return;
    }

    pushDataLayer(eventData);
  };

  const pushDataLayerV2 = (eventData: newDataLayerEvent) => {
    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
  };

  return { pushDataLayer: handlePushDataLayer, pushDataLayerV2 };
}
